const LS = {
  LAST_SESSION_PROVIDER: 'lastSessionProvider',
  LAST_SESSION: 'lastSession',
  SESSIONS: 'sessions',
  GDPR: 'gdpr',
  LOGIN_ATTEMPT_EMAIL: 'loginAttemptEmail',
  LANGUAGE: 'language'
}

export default LS
export { LS }
